import { makeStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import Tooltip from '@material-ui/core/Tooltip'
import CircularProgress from '@material-ui/core/CircularProgress'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

type Props = {
  filename: string
  extension: string
  progress: number
  status: 'uploading' | 'success'
  onRemove?: () => void
}

const useStyles = makeStyles((theme) => ({
  container: {
    width: 100,
    height: 120,
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    position: 'relative',
    marginRight: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    transition: 'opacity 0.2s ease-in-out',
  },
  topContent: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: '100%',
  },
  fileIcon: {
    fontSize: 58,
    color: theme.palette.primary.main,
  },
  extensionLabel: {
    position: 'absolute',
    top: theme.spacing(7),
    fontSize: '0.8rem',
    backgroundColor: theme.palette.background.paper,
    padding: '2px 6px',
    borderRadius: 4,
    boxShadow: theme.shadows[1],
  },
  fileName: {
    width: '100%',
    textAlign: 'center',
    fontSize: '0.92rem',
    marginTop: theme.spacing(1),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },

  tooltip: {
    fontSize: '0.90rem',
    padding: '6px 10px',
  },
}))

const FileAttachment = ({ filename, extension, progress, status, onRemove }: Props) => {
  const classes = useStyles({ status })

  return (
    <div className={classes.container}>
      {onRemove && (
        <IconButton
          size="small"
          style={{ position: 'absolute', top: 0, right: 0 }}
          onClick={onRemove}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}

      <div className={classes.topContent}>
        {status === 'uploading' && progress === 0 ? (
          <CircularProgress size={40} />
        ) : status === 'uploading' ? (
          <CircularProgress size={40} variant="determinate" value={progress} />
        ) : (
          <>
            <InsertDriveFileIcon className={classes.fileIcon} />
            <div className={classes.extensionLabel}>{extension.toUpperCase()}</div>
          </>
        )}
      </div>

      <Tooltip
        title={filename}
        PopperProps={{
          popperOptions: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
          },
        }}
        classes={{ tooltip: classes.tooltip }}
      >
        <Typography className={classes.fileName} noWrap>
          {filename}
        </Typography>
      </Tooltip>
    </div>
  )
}

export default FileAttachment
